/**
 * Reservation / Booking Page Content
 */

const reservationContent = {
  breadcrumb: {
    subtitle: 'Reservation',
    title: 'BOOK YOUR TABLE',
  },

  description:
    'Restaurant will be open for all days, Sunday night will be closed, All booking payment is secured with credit card, no charges will be aplly for online booking. no refundable.',
  bookingPhone: '+88-123-123456',
  bookingText: 'Booking request',
  poweredBy: '*Powered by OpenTable',

  contactInfo: {
    city: 'New York',
    address: 'Restaurant St, Delicious City, London 9578, UK',
    phone: '+88-123-123456',
    email: 'booking@domainname.com',
    hours: 'Sunday – Thursday : 11 AM to 2 AM  |  Friday – Saturday : 11 AM to 3 AM',
  },

  personOptions: [1, 2, 3, 4, 5, 6, 7],
  timeSlots: [
    '08 : 00 am', '09 : 00 am', '10 : 00 am', '11 : 00 am',
    '12 : 00 pm', '01 : 00 pm', '02 : 00 pm', '03 : 00 pm',
    '04 : 00 pm', '05 : 00 pm', '06 : 00 pm', '07 : 00 pm',
    '08 : 00 pm', '09 : 00 pm', '10 : 00 pm',
  ],
};

export default reservationContent;
